import CrudCustom from '../../../libs/custom/CrudCustom';

let TipeKoreksiFiskal = new CrudCustom('/tipe-koreksi-fiskals');
export default TipeKoreksiFiskal;
